import Logo from "./logo.png";
import Warehouse from "./warehouse_image.jpg";

export default {
  Logo,
  Warehouse,
};
